import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

type DataRow = { [key: string]: any };

interface ExportToExcelProps {
  data: DataRow[];
  fileName?: string;
  columns?: { header: string; key: string }[];
}

export const exportToExcel = async ({
  data,
  fileName,
  columns,
}: ExportToExcelProps) => {
  // Create a new workbook and worksheet
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet 1");

  // If columns are provided, set the headers
  if (columns && columns.length > 0) {
    worksheet.columns = columns;
  } else if (data.length > 0) {
    // If no columns are provided, use keys from the first data object
    const keys = Object.keys(data[0]);
    worksheet.columns = keys.map((key) => ({ header: key, key }));
  }

  // Add rows to the worksheet
  data.forEach((item) => {
    worksheet.addRow(item);
  });

  // Generate buffer
  const buffer = await workbook.xlsx.writeBuffer();

  // Create a Blob from the buffer
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // Use file-saver to save the file
  saveAs(blob, fileName || "data.xlsx");
};
